import React from "react";

export default class SectionSeparator extends React.Component {
  render() {
    return (
      <div className="c-separator v2 row">
        <div className="col-3">
          <hr />
        </div>
        <div className="col-6">
          <span>
            <strong>{this.props.title}</strong>
          </span>
        </div>
        <div className="col-3">
          <hr />
        </div>
      </div>
    );
  }
}
